import { computed } from 'mobx'
import get from 'lodash/get'

const actions = [
  { key: 'general_settings', icon: 'info-circle', label: 'Setup your website\'s basic information', complete: false, path: 'settings/general', description: 'Set website title, phone number, etc.', video: '223713709' },
  { key: 'search_settings', icon: 'search', label: 'Update Your Website\'s Default Search', complete: false, path: 'settings/search', description: 'Set restrictions and adjust how the search filters will initially be set on the search', video: '223352342' },
  { key: 'email_settings', icon: 'envelope', label: 'Customize Your Emails', complete: false, path: 'settings/email', description: 'Set your name, reply to, and signature', video: '223708764' },
  { key: 'registration_settings', icon: 'lock', label: 'Configure registration settings', complete: false, path: 'settings/registration', description: 'We recommended open searches but you can add a mix of registration restrictions', video: '223712561' },
  { key: 'seo_settings', icon: 'gear', label: 'Update your SEO settings', complete: false, path: 'settings/seo', description: 'Personalize your URL structure, page titles, and meta description', video: '223709639' },
  { key: 'design_settings', icon: 'paint-brush', label: 'Change colors and fonts', complete: false, path: 'settings/design', description: 'Make the search match the colors from the rest of your website', video: '223709348' },
  { key: 'lead_routing', icon: 'random', label: 'Configure lead routing', complete: false, path: 'settings/lead-routing', description: 'Make sure that the lead distribution settings set up correctly for you', video: '223710544' },
  { key: 'hotsheets', icon: 'th', label: 'Build your first hotsheet', complete: false, path: 'hotsheets/add', description: 'Start building community pages on your website', video: '220349177' },
  { key: 'recommended_searches', icon: 'bullhorn', label: 'Create your first recommended search', complete: false, path: 'recommended/searches/add', description: 'We’ll show you how to set up saved search subscriptions for your leads and clients', video: '220352485' },
]

export default class Welcome {
  websites

  @computed get website() {
    return this.websites.current
  }

  @computed get actions() {
    let activeSet = false
    return actions.map(action => {
      const complete = get(this.website, `welcome.${action.key}`, action.complete)
      const active = (!complete) && (!activeSet) && (activeSet = true)
      return { ...action, active, complete }
    })
  }

  @computed get activeAction() {
    return this.actions.find(action => action.active)
  }

  @computed get progress() {
    return this.actions.filter(action => action.complete).length / actions.length
  }

  constructor(websites) {
    this.websites = websites
  }

  getActionLinkUrl(action) {
    if (!action.path) {
      return `/website/${this.website.id}`
    }
    return () => ({
      pathname: `/website/${this.website.id}/${action.path}`,
      state: {
        welcome_action: action.key
      }
    })
  }

  update(key, complete=true) {
    const website = { ...this.website, welcome: { ...this.website.welcome, [key]:complete }}
    return this.websites.save(website)
  }

  markAll(complete=true) {
    const welcome = this.actions.reduce((w, action) => {
      w[action.key] = complete
      return w
    }, {})
    return this.websites.save({ ...this.website, welcome })
  }
}



// WEBPACK FOOTER //
// client/stores/welcome.js